import { render, staticRenderFns } from "./primeraCompra.vue?vue&type=template&id=90961a00&scoped=true&"
import script from "./primeraCompra.vue?vue&type=script&lang=js&"
export * from "./primeraCompra.vue?vue&type=script&lang=js&"
import style0 from "./primeraCompra.vue?vue&type=style&index=0&id=90961a00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90961a00",
  null
  
)

export default component.exports